let staminaStyleInjected = false;

function ensureStaminaStyle(): void {
  if (staminaStyleInjected || typeof document === 'undefined') return;
  staminaStyleInjected = true;
  const style = document.createElement('style');
  style.textContent = [
    '@keyframes fpsStaminaFlash {',
    '  0%, 100% { filter: brightness(1); opacity: 0.95; }',
    '  50% { filter: brightness(1.4); opacity: 0.55; }',
    '}',
    '@keyframes fpsStaminaEmpty {',
    '  0%, 100% { background: #ff2a2a; box-shadow: 0 0 10px rgba(255,42,42,0.8); }',
    '  50% { background: #ff7518; box-shadow: 0 0 4px rgba(255,117,24,0.3); }',
    '}',
    '@keyframes fpsSwimStaminaDrain {',
    '  0%, 100% { opacity: 0.55; transform: scaleX(1); }',
    '  50% { opacity: 1; transform: scaleX(1.02); }',
    '}',
    '.fps-stamina-low .fps-stamina-fill {',
    '  animation: fpsStaminaFlash 0.6s ease-in-out infinite;',
    '}',
    '.fps-stamina-empty .fps-stamina-fill {',
    '  animation: fpsStaminaEmpty 0.3s ease-in-out infinite !important;',
    '  width: 100% !important;',
    '}',
    '.fps-stamina-swim .fps-stamina-fill {',
    '  background: linear-gradient(90deg, #0a6ea8 0%, #1aa8e8 40%, #5fd4ff 80%, #b8ecff 100%) !important;',
    '  box-shadow: inset 0 -1px 0 rgba(0,0,0,0.25),0 0 10px rgba(42,180,255,0.55) !important;',
    '  animation: fpsSwimStaminaDrain 0.45s ease-in-out infinite;',
    '}',
    '.fps-stamina-swim {',
    '  border-color: rgba(80,200,255,0.65) !important;',
    '}',
  ].join('\n');
  document.head.appendChild(style);
}

/** Fortnite-style stamina bar located cleanly under the Shield bar. */
export class FpsStaminaHud {
  private readonly root: HTMLDivElement;
  private readonly fill: HTMLDivElement;
  private stamina = 100;
  private swimSprintActive = false;
  private disposed = false;

  constructor(mount: HTMLElement) {
    ensureStaminaStyle();
    this.root = document.createElement('div');
    this.root.className = 'fps-stamina-root';
    this.root.style.cssText = [
      'position:fixed',
      'top:64px',
      'left:14px',
      'width:180px',
      'height:6px',
      'z-index:39',
      'pointer-events:none',
      'box-sizing:border-box',
      'border:1px solid rgba(255,180,40,0.45)',
      'background:rgba(18,12,6,0.48)',
      'backdrop-filter:blur(10px)',
      '-webkit-backdrop-filter:blur(10px)',
      'border-radius:3px',
      'overflow:hidden',
      'box-shadow:0 2px 10px rgba(0,0,0,0.22),inset 0 1px 0 rgba(255,255,255,0.05)',
      'transition: opacity 0.2s ease',
    ].join(';');

    this.fill = document.createElement('div');
    this.fill.className = 'fps-stamina-fill';
    this.fill.style.cssText = [
      'position:absolute',
      'left:0',
      'top:0',
      'bottom:0',
      'width:100%',
      'background:linear-gradient(90deg, #d47600 0%, #ff9d00 35%, #ffc04d 75%, #ffdf9e 100%)',
      'box-shadow:inset 0 -1px 0 rgba(0,0,0,0.25),0 0 6px rgba(255,160,40,0.25)',
      'transition:width 0.08s ease-out',
    ].join(';');

    this.root.appendChild(this.fill);
    mount.appendChild(this.root);
    this.render();
  }

  setStamina(n: number): void {
    if (this.disposed || !Number.isFinite(n)) return;
    this.stamina = Math.max(0, Math.min(100, n));
    this.render();
  }

  /** Highlight bar while swim-sprinting (Shift in water). */
  setSwimSprintActive(active: boolean): void {
    if (this.disposed) return;
    this.swimSprintActive = active;
    this.root.classList.toggle('fps-stamina-swim', active);
    if (active) {
      this.root.style.opacity = '1';
    } else {
      this.render();
    }
  }

  getStamina(): number {
    return this.stamina;
  }

  private render(): void {
    const isLow = this.stamina < 25;
    const isEmpty = this.stamina <= 0.5;

    this.root.classList.toggle('fps-stamina-low', isLow && !isEmpty);
    this.root.classList.toggle('fps-stamina-empty', isEmpty);

    if (isEmpty) {
      this.fill.style.width = '100%';
    } else {
      this.fill.style.width = `${this.stamina}%`;
    }

    // Fade out when fully recharged unless swim-sprinting
    if (this.stamina >= 99.5 && !this.swimSprintActive) {
      this.root.style.opacity = '0';
    } else {
      this.root.style.opacity = '1';
    }
  }

  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.root.remove();
  }
}
